import { render } from "./RrhhPage.vue?vue&type=template&id=c8f507bc"
import script from "./RrhhPage.vue?vue&type=script&lang=js"
export * from "./RrhhPage.vue?vue&type=script&lang=js"

import "./RrhhPage.vue?vue&type=style&index=0&id=c8f507bc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__